// extracted by mini-css-extract-plugin
export default {"title":"styles_title__uT2S0","subtitle":"styles_subtitle__bRkeS"};